import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { getRequest, postRequest } from '../../../../utils/axiosRequests';

const SelectedItemSearch = ({
  apiUrl,
  selectedItemName,
  selectedItems,
  selectedItemsAction,
  observation = false,
  medical = false,
}) => {
  const [options, setOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState(selectedItemName);
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef(null);

  const handleOnInputChange = async (searchKey) => {
    setIsLoading(true);
    if (searchKey) {
      const url = `${apiUrl}?name=${encodeURIComponent(searchKey)}`;
      setSearchQuery(searchKey);
      await getRequest(url)
        .then((data) => {
          setOptions(data?.data);
          setIsLoading(false);
        })
        .catch(console.error);
    }
  };

  useEffect(() => {
    setOptions([{ name: selectedItemName, value: selectedItemName }]);
  }, [selectedItemName]);

  const handleOnSelect = async (selectedOption) => {
    try {
      const { name: selectedData, customOption: isNewOption } =
        selectedOption[0];
      if (isNewOption) {
        await postRequest(apiUrl, {
          name: selectedData,
        });
      }

      if (medical) {
        const updatedData = selectedItems?.medical?.map((item) =>
          item.name === selectedItemName
            ? { ...item, name: selectedData }
            : item,
        );
        selectedItemsAction({
          ...selectedItems,
          medical: updatedData,
        });
      } else if (observation) {
        const updatedData = selectedItems?.observations?.map((item) =>
          item.name === selectedItemName
            ? { ...item, name: selectedData }
            : item,
        );
        selectedItemsAction({
          ...selectedItems,
          observations: updatedData,
        });
      } else {
        const updatedItems = selectedItems?.map((item) =>
          item.name === selectedItemName
            ? { ...item, name: selectedData }
            : item,
        );
        selectedItemsAction(updatedItems);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Fragment>
      <div className="selected-search-icon">
        <svg width="16" height="16" viewBox="0 0 20 20">
          <path
            d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
            stroke="currentColor"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </div>
      <Typeahead
        allowNew
        labelKey="name"
        ref={ref}
        id="selected-item-typehead"
        newSelectionPrefix="Add new: "
        options={options}
        selected={(() => {
          const match = options.find((opt) => opt.name === searchQuery);
          return match ? [match] : [];
        })()}
        onChange={handleOnSelect}
        onInputChange={handleOnInputChange}
        size="sm"
        renderMenuItemChildren={(option) => (
          <Fragment>
            <span>{option.name}</span>
          </Fragment>
        )}
      />
    </Fragment>
  );
};

export default SelectedItemSearch;
